import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';

import media from 'apps/auth/theme/media';

type ContainerProps = {
    isLinked?: boolean;
    isHoverable?: boolean;
};

const TopCutoutWhite = (props: { theme: DefaultTheme }) => {
    return `url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' width='48' height='16' viewBox='0 0 48 16'%3E%3Crect fill='%23${props.theme.white_for_svg}' width='48' height='16'/%3E%3Cpath fill='%23${props.theme.white_for_svg}' stroke='%23${props.theme.grey_40_lc_for_svg}' stroke-opacity='.28' d='M0,0.5h7.175c2.583,0,4.859,1.705,6.418,3.765C15.461,6.731,18.73,9.5,24,9.5 s8.539-2.769,10.406-5.235c1.559-2.06,3.836-3.765,6.419-3.765H48'/%3E%3C/svg%3E")`;
};

const getCutOut = (props: ContainerProps & { theme: DefaultTheme }) => {
    if (props.isHoverable) {
        return `url("data:image/svg+xml,%3Csvg width='48' height='16' viewBox='0 0 48 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='48' height='16' fill='%23${props.theme.white_for_svg}' /%3E%3Cpath d='M0 15.68H48V0.320007H39.2133C36.455 0.320007 34.2962 2.04229 32.9197 3.82709C31.1437 6.12977 27.8143 7.68001 24 7.68001C20.1857 7.68001 16.8563 6.12977 15.0803 3.82709C13.7038 2.04229 11.545 0.320007 8.78666 0.320007H0V15.68Z' fill='%23${props.theme.grey_8_lc_for_svg}' /%3E%3Cpath d='M0 0.5H7.175C9.758 0.5 12.034 2.205 13.593 4.265C15.461 6.731 18.73 9.5 24 9.5C29.27 9.5 32.539 6.731 34.406 4.265C35.965 2.205 38.242 0.5 40.825 0.5H48' fill='%23${props.theme.white_for_svg}' /%3E%3Cpath d='M0 0.5H7.175C9.758 0.5 12.034 2.205 13.593 4.265C15.461 6.731 18.73 9.5 24 9.5C29.27 9.5 32.539 6.731 34.406 4.265C35.965 2.205 38.242 0.5 40.825 0.5H48' stroke='%23${props.theme.grey_40_lc_for_svg}' stroke-opacity='0.28'/%3E%3C/svg%3E%0A")`;
    }
    return `url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' width='48' height='16' viewBox='0 0 48 16'%3E%3Crect fill='%23${props.theme.white_for_svg}' width='48' height='16'/%3E%3Cpath fill='%23${props.theme.white_for_svg}' stroke='%23${props.theme.grey_40_lc_for_svg}' stroke-opacity='.28' d='M0,0.5h7.175c2.583,0,4.859,1.705,6.418,3.765C15.461,6.731,18.73,9.5,24,9.5 s8.539-2.769,10.406-5.235c1.559-2.06,3.836-3.765,6.419-3.765H48'/%3E%3C/svg%3E")`;
};

export const AccountsListContainer = styled.div<ContainerProps>`
    border: 1px solid ${(props) => props.theme.grey_28_tr};
    border-radius: 12px;
    padding: 24px;
    position: relative;
    cursor: ${(props) => (props.isHoverable ? 'pointer' : null)};

    ${media.desktop1920} {
        padding: 32px;
        border-radius: 16px;
    }

    &:before {
        display: ${(props) => (props.isLinked ? 'inline-block' : 'none')};
        content: '';
        position: absolute;
        left: 50%;
        margin-left: -24px;
        top: -1px;
        width: 48px;
        height: 16px;
        background-image: ${TopCutoutWhite};
    }

    &:hover {
        background: ${(props) => (props.isHoverable ? props.theme.grey_8_lc : null)};
        &:before {
            background-image: ${getCutOut};
        }
    }
`;
